import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import DepositACheckPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/DepositACheckPage";
import Classes, { Account } from "model";

export default function CaptureMabiDepositsCheckFrontDone(props){
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "deposit", "account" ], Account.initByID(account.id))
        .update([ "deposit", "amount" ], 20)
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "checkFrontView", "isSet" ], true)
        .submit();

    return <DepositACheckPage data={ data } ui={ ui } />
}